import type { ActivitiesFiltersParams } from '@recruitee/activities-types';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

import { EntityStoreKey, NotificationCounterFilteredStore } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<NotificationCounterFilteredStore>()(
    EntityStoreKey.notificationsCounterFiltered,
    {
      customActions: adapter => ({
        fetch: (state, payload: { filters: ActivitiesFiltersParams }) =>
          pipeState(state, next => adapter.markAsPending(next)),
      }),
    },
  );

export {
  actions as NotificationsCounterFilteredActions,
  selectors as NotificationsCounterFilteredSelectors,
  reducer as NotificationsCounterFilteredReducer,
  namespace as NotificationsCounterFilteredNamespace,
};
